<template>
  <div id="app">
      <!-- 路由匹配到的组件将显示在这里 -->
      <!-- <router-view> </router-view>  -->
      <keep-alive>
          <router-view v-if="$route.meta.keepAlive">
              <!-- 这里是会被缓存的视图组件，比如 page1,page2 -->
          </router-view>
      </keep-alive>
      
      <router-view v-if="!$route.meta.keepAlive">
          <!-- 这里是不被缓存的视图组件，比如 page3 -->
      </router-view>
      <!-- 底部tabbar 组件 -->
      <AppTabBar v-show="$route.meta.isShowTabbar" ref="AppTabBar"></AppTabBar>
  </div>
</template>

<script>
import AppTabBar from "@/components/AppTabBar";

export default {
  name: 'App',
  components: {
    AppTabBar,
  },

}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
